import { render, staticRenderFns } from "./TagUI.vue?vue&type=template&id=0ab10df3&scoped=true&"
import script from "./TagUI.vue?vue&type=script&lang=ts&"
export * from "./TagUI.vue?vue&type=script&lang=ts&"
import style0 from "./TagUI.vue?vue&type=style&index=0&id=0ab10df3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab10df3",
  null
  
)

export default component.exports